import { ClipCreator } from "./ClipCreator";
import { ClipExport } from "./ClipExport";
import { AudioBufferClip } from "../../../../../../library-js/audio/AudioBufferClip";
import { AudioMath } from "../../../../../../library-js/audio/AudioMath";

export class Trimming
{
  exporter:ClipCreator;

  async trim():Promise<void>
  {
    if ( 
     ! ( this.exporter.settings.trimming.trimStart.enabled || 
         this.exporter.settings.trimming.trimEnd.enabled || 
         this.exporter.settings.trimming.durationTrimming 
        )
    )

    {
      return Promise.resolve();
    }

    let tresholdDB = this.exporter.settings.trimming.tresholdDecibels;
    let tresholdAmplitude = AudioMath.decibelToAmplitude( tresholdDB );
    
    console.log( "Trimming:", tresholdDB, ">>", tresholdAmplitude );
    
    this.exporter.settings.exports.forEach( c => this.trimClip( c ) );
  }

  trimClip( clip:ClipExport )
  {
    let audioBuffer = this.exporter.editor.project.audioBuffer;
    let bufferClip = AudioBufferClip.createFromStartAndEndTime( audioBuffer, clip.startTime, clip.endTime );

    let tresholdDB = this.exporter.settings.trimming.tresholdDecibels;
    let tresholdAmplitude = AudioMath.decibelToAmplitude( tresholdDB );

    let trimmedStart = clip.startTime;
    let trimmedEnd   = clip.endTime;


    if ( this.exporter.settings.trimming.trimStart.enabled )
    {
      if ( bufferClip.trimStart( tresholdAmplitude ) )
      {
        clip.trimmed = true;
        clip.trimmedStartTime = bufferClip.startTime;
        clip.trimmedEndTime   = trimmedEnd;        

        trimmedStart  = clip.trimmedStartTime;

        bufferClip = AudioBufferClip.createFromStartAndEndTime( audioBuffer, clip.startTime, clip.endTime );
      }

    }

    let duration =  ClipExport.getTimeDuration( clip );

    console.log( "Duration:", duration, this.exporter.settings.trimming.maxDuration, duration > this.exporter.settings.trimming.maxDuration );
    if ( this.exporter.settings.trimming.durationTrimming && 
         duration > this.exporter.settings.trimming.maxDuration )
    {
      console.log( "Trimming to max duration:", clip.clipName );
      clip.trimmed = true;
      clip.trimmedStartTime = trimmedStart;
      clip.trimmedEndTime   = trimmedStart + this.exporter.settings.trimming.maxDuration;

      clip.fadeOutDuration = this.exporter.settings.trimming.durationTrimmingFadeDuration;

      bufferClip = AudioBufferClip.createFromStartAndEndTime( audioBuffer, clip.trimmedStartTime, clip.trimmedEndTime );
    }
    

    if ( this.exporter.settings.trimming.trimEnd.enabled )
    {
      if ( bufferClip.trimEnd( tresholdAmplitude ) )
      {
        clip.trimmed = true;
        clip.trimmedStartTime = trimmedStart;
        clip.trimmedEndTime   = bufferClip.endTime;      

        trimmedEnd = bufferClip.endTime;
      }
    }

  }

}